import request, { formatRequest } from "@/utils/request"

import { IPackageList, UpdateSpendLimitData } from "./type"

const APIPlan = {
  /**
   * 获取店铺套餐权限
   * 无需传商家id，后台会从token上进行识别
   */
  getStoreAuthority() {
    return formatRequest(
      request.get("/go-api/v1/shop/subscribe/subscribeBenefit"),
    )
  },

  /**
   * 获取套餐列表
   */
  getPackageList() {
    return formatRequest<IPackageList>(
      request.get("/go-api/v1/shop/subscribe/packageList"),
    )
  },

  resumePlan() {
    return formatRequest(request.post("/go-api/v1/shop/subscribe/resume"))
  },

  /**
   * 更新订阅扣费上限
   * @see POST /go-api/v1/shop/subscribe/update_spend_limit
   */
  updateSpendLimit(spend_limit_cost: number) {
    return formatRequest<UpdateSpendLimitData>(
      request.post("/go-api/v1/shop/subscribe/update_spend_limit", {
        spend_limit_cost,
      }),
      {
        success: {
          1000: t("SavedSuccessfully"),
        },
        error: {
          "*": t("SavedFailed"),
        },
      },
    )
  },
  /**
   * 创建付费订阅
   * @param package_id 套餐ID
   * @param kind 套餐类型
   */
  createStorePaidSubscribe(package_id: number, kind: number) {
    return formatRequest(
      request.post("/go-api/v1/shop/subscribe/create", {
        package_id: package_id,
        kind,
      }),
    )
  },

  /**
   * 开启或关闭某一项
   * @param package_id 套餐ID
   * @param kind 套餐类型
   */
  setShopExtraEnable(kind: number, enable: number) {
    return formatRequest(
      request.post("/go-api/v1/com/shop/extra_enable", {
        enable,
        kind,
      }),
      {
        success: {
          1000: t("OperationSuccessful"),
        },
      },
    )
  },
}

export default APIPlan
